import type { PaywallViewedProperties } from '@shared/core/analytics'
import { getEventDate, ListEventsResponseEntry } from '@shared/core/events'
import { format } from 'date-fns'
import { formatInTimeZone } from 'date-fns-tz'
import { buildUpgradePlansPath } from 'src/modules/payment/utils/upgrade-funnel-navigation'

export const PAUSED_REMINDERS_MODAL_VIEW_PROPERTIES: PaywallViewedProperties = {
  surface: 'first_login_modal',
  display: 'programmatic',
  trigger: 'quota_exhausted',
  account_state: 'free_exhausted',
  source_page: 'dashboard',
}

// The relay drops `source_element` unless `display` is `user_click`, so the
// dashboard card's own attribution only survives on this variant.
export const PAUSED_REMINDERS_MODAL_CARD_VIEW_PROPERTIES: PaywallViewedProperties = {
  ...PAUSED_REMINDERS_MODAL_VIEW_PROPERTIES,
  display: 'user_click',
  source_element: 'dashboard_plan_card',
}

export const PAUSED_REMINDERS_MODAL_PLANS_PATH = buildUpgradePlansPath({
  trigger: 'quota_exhausted',
  source_element: 'first_login_modal_cta',
  source_page: 'dashboard',
})

export const ENDED_REMINDERS_MODAL_VIEW_PROPERTIES: PaywallViewedProperties = {
  surface: 'first_login_modal',
  display: 'programmatic',
  trigger: 'subscription_ended',
  account_state: 'subscription_ended',
  source_page: 'dashboard',
}

export const ENDED_REMINDERS_MODAL_CARD_VIEW_PROPERTIES: PaywallViewedProperties = {
  ...ENDED_REMINDERS_MODAL_VIEW_PROPERTIES,
  display: 'user_click',
  source_element: 'dashboard_plan_card',
}

export const ENDED_REMINDERS_MODAL_PLANS_PATH = buildUpgradePlansPath({
  trigger: 'subscription_ended',
  source_element: 'first_login_modal_cta',
  source_page: 'dashboard',
})

export function formatAtRiskAppointmentStart(event: ListEventsResponseEntry, timezone: string): string {
  const start = getEventDate(event)

  // All-day starts are calendar dates already resolved to local midnight.
  if (event.all_day) {
    return format(start, 'EEE, LLL d')
  }

  return formatInTimeZone(start, timezone, 'EEE, LLL d · h:mm a')
}
